<div class="sc-item-wrapper" [attr.size]="size" [attr.active]="isActive" [attr.hover]="isHover" [attr.press]="isPress" [attr.focus]="isFocus">
    <div class="focus-ring" *ngIf="isFocus" [attr.active]="isActive" [attr.size]="size"></div>
    <rr-icon *ngIf="icon" [name]="icon"></rr-icon>
    <div class="label-container">
        {{ name }}
    </div>
</div>
